import React from 'react';
import { Row, Col, Form } from 'react-bootstrap';

import {
  COST_VALUE_OPTS,
  USAGE_VALUE_OPTS,
  OPERTATION_OPTS,
  PRIORITY_COUNT_OPTIONS,
} from './helpers';
import PlugTemplateClauseGroup from './PlugTemplateClauseGroup';
export default function PlugTemplateRule(props) {
  const {
    ruleType,
    activeTemplate,
    editRule,
    updateRow,
    clausesBoolen,
    setClausesBoolean,
    localClauses,
    setLocalClauses,
    clauseId,
    setClauseId,
  } = props;

  const LOCAL_LOCATION_OPTS =
    ruleType === 'usage' ? activeTemplate.usage_names : activeTemplate.cost_names;
  const LOCAL_VALUE_OPTS =
    ruleType === 'usage' ? USAGE_VALUE_OPTS : COST_VALUE_OPTS;

  return (
    <>
      <Row style={{ paddingLeft: '1em', marginTop: '1em' }}>
        <PlugTemplateClauseGroup
          ruleType={ruleType}
          clausesBoolen={clausesBoolen}
          setClausesBoolean={setClausesBoolean}
          localClauses={localClauses}
          setLocalClauses={setLocalClauses}
          clauseId={clauseId}
          setClauseId={setClauseId}
        />
      </Row>
      <Row style={{ paddingLeft: '1em' }}>
        <u>Basic Rule Info</u>
      </Row>
      <Row style={{ padding: '1em' }}>
        <Col md={3}>
          <Form.Label>Rule Name</Form.Label>
          <Form>
            <Form.Control
              defaultValue={editRule.name}
              onChange={(e) => updateRow('name', e.target.value)}
            />
          </Form>
        </Col>
        <Col md={3}>
          <Form>
            <Form.Label>
              {ruleType === 'usage' ? 'Usage' : 'Cost'} Location
            </Form.Label>
            <Form.Control
              as='select'
              required
              value={editRule.rule_location}
              onChange={(e) =>
                updateRow('rule_location', parseInt(e.target.value))
              }
            >
              <option key={'null'} value={null}>  {`Default ${ruleType === 'usage' ? 'Usage' : 'Cost'}`}</option>
              {(LOCAL_LOCATION_OPTS && LOCAL_LOCATION_OPTS.length > 0) && LOCAL_LOCATION_OPTS.map((opt, idx) => (
                <option key={`location-opt-${idx}`} value={idx}>
                  {opt && opt !== '' ? opt : `${ruleType === 'usage' ? 'Usage' : 'Cost'} ${idx + 1}`}
                </option>
              ))
              }
            </Form.Control>
          </Form>
        </Col>
        <Col md={2}>
          <Form>
            <Form.Label>
              {ruleType === 'usage' ? 'Usage' : 'Cost'} Value
            </Form.Label>
            <Form.Control
              as='select'
              required
              value={editRule.rule_value}
              onChange={(e) =>
                updateRow('rule_value', parseInt(e.target.value))
              }
            >
              {Object.keys(LOCAL_VALUE_OPTS).map((opt) => (
                <option key={`value-opt-${opt}`} value={opt}>
                  {LOCAL_VALUE_OPTS[opt]}
                </option>
              ))}
            </Form.Control>
          </Form>
        </Col>
        <Col md={2}>
          <Form>
            <Form.Label>Operation</Form.Label>
            <Form.Control
              as='select'
              required
              value={editRule.operation}
              onChange={(e) => updateRow('operation', parseInt(e.target.value))}
            >
              {Object.keys(OPERTATION_OPTS).map((opt) => (
                <option key={`operation-opt-${opt}`} value={opt}>
                  {OPERTATION_OPTS[opt]}
                </option>
              ))}
            </Form.Control>
          </Form>
        </Col>
        <Col md={2}>
          <Form.Group controlId='template.usage_count' >
            <Form.Label>
              Rule Priority (#)
            </Form.Label>
            <Form.Control
              as='select'
              required
              value={editRule.rule_priority}
              onChange={(e) =>
                updateRow('rule_priority', parseInt(e.target.value))
              }
            >
              {PRIORITY_COUNT_OPTIONS.map((opt) =>
                <option key={`usage-opt${opt}`} value={opt}>
                  {opt}
                </option>
              )}
            </Form.Control>
          </Form.Group>
        </Col>
      </Row>
    </>
  );
}
